import { useAuth } from "../contexts/AuthProvider/AuthProvider"


export const useCurrentUserId = () => {
    const userId = useAuth().user.userId;
    return userId;
}